import { ArrowLeft, LockKeyhole, UserRound } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Brand } from "../../../components/SiteChrome";
import { useAuth } from "../../../context/AuthContext";
import { roleHome } from "../../../utils/roleHome";

export function CheckoutHeader() {
  const { isAuthenticated, user } = useAuth();
  useEffect(() => { document.title = "Secure checkout | Formula Soccer"; }, []);
  return (
    <header className="checkout-header">
      <Link to="/" className="checkout-brand" aria-label="Formula Soccer home"><Brand compact icon /></Link>
      <div className="checkout-header-copy"><LockKeyhole size={16} aria-hidden="true" /><span><strong>Secure checkout</strong><small>Your enrollment is protected</small></span></div>
      <nav aria-label="Checkout navigation"><Link to="/memberships"><ArrowLeft size={15} /> Memberships</Link>{isAuthenticated && <Link to={roleHome(user?.role)}><UserRound size={15} /> Account</Link>}</nav>
    </header>
  );
}
